import { FormValues } from '../../funnel/types';

export interface InputController {
  value: string;
  readonly input?: HTMLInputElement;
  readonly type: string;
  readonly name: string;
  readonly resetOptions?: () => void;
}

// code for styleguide inputs
export function textInput(element: HTMLElement, formValues: FormValues = {}): InputController | undefined {
  const field = element.querySelector('.otto-field-wrapper');
  if (!field) {
    return;
  }
  const input = field.querySelector('.otto-field') as HTMLInputElement;
  const defaultValue = formValues[input.name as keyof FormValues] || input.value;

  // update disabled and empty classes on wrapper for large inputs
  input.addEventListener('update', () => {
    element.classList.toggle('disabled', input.disabled);
    element.classList.toggle('empty', !input.value);
  });
  input.addEventListener('input', () => {
    element.classList.toggle('empty', !input.value);
  });

  // bouncer error integration
  input.addEventListener('bouncerShowError', () => {
    element.classList.add('error');
  });
  input.addEventListener('bouncerRemoveError', () => {
    element.classList.remove('error');
  });

  input.value = defaultValue;
  input.dispatchEvent(new Event('update'));

  //click on prefix/suffix should focus input too
  field.addEventListener('click', e => {
    if (e.target !== input) {
      input.focus();
    }
  });

  //TODO set up global object in typescript
  //@ts-ignore
  if (input.name === 'date_of_birth' && !input.imask) {
    //@ts-ignore
    const initMask = input => window.initMask(input);

    //@ts-ignore
    if (!window.initMask) {
      window.addEventListener('initIMask', () => {
        initMask(input);
      });
    } else {
      initMask(input);
    }
  }

  return {
    set value(value: string) {
      if (value === input.value) {
        return;
      }
      input.value = value;
      input.dispatchEvent(new Event('update'));
    },
    get value() {
      return input.value;
    },
    resetOptions: () => {
      input.querySelectorAll('option').forEach((option, index) => {
        if (index === 0) {
          option.selected = true;
        } else {
          option.remove();
        }
      });
    },
    input,
    type: input.type,
    name: input.name
  };
}

export function radioInput(element: HTMLElement, formValues: FormValues = {}): InputController | undefined {
  const radios = Array.from(element.querySelectorAll<HTMLInputElement>('input[type="radio"]'));

  if (!radios.length) {
    return;
  }

  const name = radios[0].name;

  const controller = {
    set value(value: string) {
      const activeRadio = radios.find(radio => radio.value === value);
      if (activeRadio) {
        activeRadio.checked = true;
      }
    },
    get value() {
      return radios.find(radio => radio.checked === true)?.value || '';
    },
    type: 'radio',
    name
  };

  const defaultValue = formValues[name as keyof FormValues];
  if (defaultValue) {
    controller.value = defaultValue;
  }

  //@ts-ignore
  radios.forEach(radio => (radio.controller = controller));

  return controller;
}

export function checkboxInput(element: HTMLElement, formValues: FormValues = {}): InputController | undefined {
  const checkbox = element.querySelector<HTMLInputElement>('input[type="checkbox"]');
  if (!checkbox) {
    return;
  }
  const defaultValue = formValues[checkbox.name as keyof FormValues] === 'on';
  checkbox.checked = defaultValue;

  return {
    set value(value: string) {
      checkbox.checked = value === 'on';
    },
    get value() {
      return checkbox.checked ? 'on' : 'off';
    },
    type: 'checkbox',
    name: checkbox.name
  };
}
